import type React from 'react';
import { forwardRef } from 'react';

import * as styles from './BlankButton.css';

/** Like a normal button, but without any styling */
export const BlankButton: React.FunctionComponent<
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
> = ({ children, ...props }) => (
  <button className={styles.button} type="button" {...props}>
    {children}
  </button>
);

export const ForwardedBlankButton = forwardRef<
  HTMLButtonElement,
  React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  >
>(({ children, ...props }, ref) => (
  <button className={styles.button} type="button" {...props} ref={ref}>
    {children}
  </button>
));
